import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.scss'],
})
export class UserCardComponent  implements OnInit {

  @Input() user: any;

  constructor(private router: Router) { }

  ngOnInit() {
  }

  redirectTo() {
    if (!this.user.link) return;
    this.router.navigate([this.user.link]);
  }
}
